angular.module('iqxCore')
	.controller('CandidateHomeCtrl', function ($scope, ApiSvc, $location, $window, serviceWorkerSvc, $cookies, $routeParams, SweetAlert, ApplicationSvc, FormSvc, $sce) {
		$scope.checkPermissions('CANDIDATE')
		$scope.display = false
		$scope.notificationsEnabled = (window.localStorage.getItem('tokenSavedOnServer') == 1)
		$scope.isiOS = !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform)
		$scope.headlineHTML = ''			

		if ($routeParams && $routeParams.pushToken) {
			var pushToken = $routeParams.pushToken
			serviceWorkerSvc.registerIOSPush(pushToken)
		}

		$scope.navigateToPage = (path) => {
			$location.url(path)
		}

		$scope.reqNotifications = async function (enableOrDisable) {
			if (enableOrDisable === true) {
				if ($cookies.get('pushPermissions') !== 1) {
					return serviceWorkerSvc.registerPush(true)
						.then(function () {
							$scope.notificationsEnabled = true
						})
				} else {
					return serviceWorkerSvc.getRegToken()
						.then(function () {
							$scope.notificationsEnabled = true
						})
				}
			} else { // We're turning it off!
				await serviceWorkerSvc.turnOff()
					.then(function () {
						$scope.notificationsEnabled = false
					})
			}
		}

		$scope.downloadApp = (v) => {
			if (v == 'ios') {
				$window.open('https://apps.apple.com/app/apple-store/id' + $scope.params.IOSAPP, '_blank')
			}
			if (v == 'android') {
				$window.open('https://play.google.com/store/apps/details?id=' + $scope.params.ANDROIDAPP, '_blank')
			}
		}

		$scope.fetch = async () => {
			await ApiSvc.fetch($scope, { fetchAPI: 'callresult/NetCandidatePersonWebHeadline', fetchTarget: 'personHeadline', fetchWithPersonID: true }).then(function () { $scope.headlineHTML = $sce.trustAsHtml($scope.personHeadline.pHeadline)})

			if ($scope.isSwitchedOn("SHOWBULLETIN")){
				await ApiSvc.fetch($scope, {fetchAPI: 'callresult/NetCandidateBulletin?pDivisionID='+ApplicationSvc.currentUser.registrationDetails.DivisionID, fetchTarget: 'bulletin', fetchWithPersonID: true, multiRow: true })
				.then(function () { 
					$scope.bulletin.forEach(bulletin => {
						// used to find how much space the HTMLBody element is taking up
						var contentWidth = document.getElementsByClassName('content')[0].offsetWidth
						if(window.innerWidth > 767){
							contentWidth = contentWidth /2
						}
						contentWidth = contentWidth - 140
						var bulletinTextWidth = ApplicationSvc.measureText(bulletin.HTMLBody)

						// show read more button
						if(bulletinTextWidth > contentWidth){
							bulletin.HTMLPreviewFlag = true
						}
						
						bulletin.HTMLBody = $sce.trustAsHtml(bulletin.HTMLBody)
						bulletin.HTMLTitle = $sce.trustAsHtml(bulletin.HTMLTitle)
					})
				})
			}
			await ApiSvc.fetch($scope, { fetchAPI: 'callresult/NetCandidateProvTimesheetCount?pCompleted=0', fetchWithPersonID: true, fetchTarget: 'timesheetCount', multiRow: false })
			await ApiSvc.fetch($scope, { fetchAPI: 'callresult/NetCandidateCountUnacceptedShifts', fetchTarget: 'unacceptedShiftsCount', multiRow: false })
			await ApiSvc.fetch($scope, { fetchAPI: 'callresult/NetCandidateDocumentsAboutToExpire', fetchWithPersonID: true, fetchTarget: 'DocsAboutToExpire', multiRow: true })
			if ($scope.isSwitchedOn("CANDMISSINGITEMS")) {
				await ApiSvc.fetch($scope, { fetchAPI: 'callresult/NetCandidateMissingItems', fetchTarget: 'missingItems', multiRow: true })
			}

			await  ApiSvc.fetch($scope, { fetchAPI: 'callresult/NetUpdatePermissions', fetchTarget: 'x', fetchWithPersonID: true })
		}	

		$scope.openDocHelpText = function (doc) {
			SweetAlert.swal({
				title: doc.Description,
				html: (/<.+>/g.exec(doc.HelpText) ? doc.HelpText : `<pre>${doc.HelpText}</pre>`),
				customClass: 'preFix'
			})
		}

		$scope.bulletinInfo = function (item) {
			item.modalBody = /<.+>/g.exec(item.HTMLBody) ? item.HTMLBody : $sce.trustAsHtml(`<pre>${item.HTMLBody}</pre>`)
			return FormSvc.modalInfo($scope,'bulletinInfo', item)
		}

		$scope.goToSettings = function(){
			return $scope.navigateToPage('/settings')
		}

		$scope.fetch()
			.then(function () {
				if ($scope.x.MarkedForDeletion > 0) {
					ApplicationSvc.currentUser.markedForDeletion = true
				}
				$scope.display = true
			})
	})
